var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"mode":"out-in","name":"fade-left"}},[(_vm.errorMessage)?_c('div',{staticClass:"flex flex-col justify-center items-center p-6 rounded-xl w-full",class:{
      'bg-coral-red-light': !_vm.isWarning,
      'bg-papaya-whip': _vm.isWarning,
    }},[_c('span',{staticClass:"mb-2 font-bold text-2xl",class:{
        'text-coral-red': !_vm.isWarning,
        'text-reddish-orange': _vm.isWarning,
      }},[_vm._v(" "+_vm._s(_vm.errorMessage.title)+" ")]),_c('span',{staticClass:"font-medium text-black text-xl text-center flex flex-wrap"},[_vm._v(" "+_vm._s(_vm.errorMessage.text)+" ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }